// Company details shared by the navbar, footer and contact page.
// Keep public/index.html (JSON-LD) in sync when these change.
export const SITE = {
  name: 'AKKA Demir Çelik',
  legalName: 'AKKA Demir Çelik Sanayi ve Ticaret Ltd. Şti.',
  url: 'https://akkademircelik.com',
  phone: '+90 532 794 79 63',
  phoneHref: 'tel:+905327947963',
  email: 'info@akkademircelik.com',
  street: 'Alaaddinbey Mah. Taşlıpare Sok. No:76/2',
  city: '16285 Nilüfer / Bursa',
  lat: 40.198375,
  lng: 28.922428,
};

// Labels come from UI[lang].nav in src/i18n.js
export const NAV_LINKS = [
  { to: '/', key: 'home' },
  { to: '/company', key: 'company' },
  { to: '/research', key: 'research' },
  { to: '/services', key: 'services' },
  { to: '/contact', key: 'contact' },
];

export const SERVICE_ANCHORS = ['lazer-kesim', 'abkant-bukum', 'kaynakli-imalat', 'tasarim'];
